import axios from "axios";
import { notification } from "antd";
import { refreshAccessToken } from "./refreshToken";

const satAxios = axios.create({
  baseURL: process.env.REACT_APP_SAT_API_URL,
});

satAxios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const bodyCode = error.response?.data?.code;
    const bodyMessage = String(
      error.response?.data?.message || "",
    ).toLowerCase();
    const isTokenExpired =
      bodyCode === "412" && bodyMessage.includes("token expired");

    const isNeedRelogin =
      bodyCode === "411" && bodyMessage.includes("need re-login");

    if (isNeedRelogin) {
      console.log("[satAxios] isNeedRelogin = true, showing session-expired notification");
      notification.error({
        key: "session-expired",
        message: "",
        description: "Sesi Anda telah berakhir",
      });
      return Promise.reject(error);
    }

    if (isTokenExpired && !error.config?.skipTokenRefresh) {
      const retryCount = error.config.__tokenRetryCount || 0;
      if (retryCount < 3) {
        try {
          const newToken = await refreshAccessToken();
          error.config.__tokenRetryCount = retryCount + 1;
          if (error.config.headers) {
            error.config.headers.token = newToken;
          }
          return satAxios.request(error.config);
        } catch (refreshErr) {
          throw refreshErr;
        }
      }

      notification.error({
        key: "token-refresh-failed",
        message: "Gagal memperbarui token",
        description: "Silahkan coba lagi.",
      });
      localStorage.clear();
      return Promise.reject(error);
    }

    throw error;
  },
);

export default satAxios;
